import { defineRecipe } from '@chakra-ui/react';

export const buttonRecipe = defineRecipe({
  base: {
    fontWeight: 'medium',
    borderRadius: '40px',
    color: 'fgPrimary',
    _disabled: {
      bg: 'bgSecondary',
      color: 'fgPrimary',
      pointerEvents: 'none',
      cursor: 'default',
    },
    _focusVisible: {
      outline: 'none',
    },
    _active: {
      bg: 'bgSecondary',
    },
    cursor: 'pointer',
  },
  variants: {
    variant: {
      outline: {
        _hover: {
          bg: 'transparent',
          borderColor: 'fgPrimary',
        },
      },
    },
    color: {
      critical: {
        bg: 'bgCompDanger',
        color: 'white',
        _hover: {
          bg: 'bgCompDanger',
        },
      },
      primary: {
        bg: 'bgCompPrimaryInverse',
        color: 'fgPrimaryInverse',
        _hover: {
          bg: 'bgCompPrimaryInverse',
        },
      },
    },
  },
});

export { Button } from '@chakra-ui/react';
